import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconPen = props => (
  <SvgIcon {...props} viewBox="0 0 15.999665 15.999665">
    <path d="m0 12.667v3.333h3.3329l9.8301-9.83-3.333-3.3326-9.83 9.8296zm15.74-10.327-2.08-2.0797c-0.34662-0.34662-0.90654-0.34662-1.2532 0l-1.6264 1.6264 3.3329 3.3329 1.6264-1.6264c0.34662-0.34662 0.34662-0.90654 0-1.2532z" />
  </SvgIcon>
);

export default IconPen;



// WEBPACK FOOTER //
// ./src/components/icons/IconPen.js